import UserActionTypes from './user.types';
import { PURGE } from 'redux-persist';

const INITITAL_STATE = {
  currentUser: null,
  role: null,
  error: null,
};

//ES6 synntax leverage assignment if state is undefined, but if state == null then the INITIAL_STATE is not leveraged
const userReducer = (state = INITITAL_STATE, action) => {
  switch (action.type) {
    case UserActionTypes.SIGN_IN_SUCCESS:
      return {
        ...state,
        currentUser: action.payload.user,
        role: action.payload.role,
        error: null,
      };

    case UserActionTypes.SIGN_OUT_FAILURE:
    case UserActionTypes.SIGN_IN_FAILURE:
      return { ...state, error: action.payload };

    case UserActionTypes.SIGN_OUT_SUCCESS:
      return { ...state, currentUser: null, error: null, role: null };

    case UserActionTypes.SET_CURRENT_USER_ROLE:
      return { ...state, role: action.payload };

    case PURGE:
      return INITITAL_STATE;

    default:
      return state;
  }
};

export default userReducer;
